import React, { useState, useEffect } from "react";
import { Modal } from 'react-responsive-modal';
import dataLoaderServices from "./DataLoaderServices";
import DataLoaderInvalid from "./DataLoaderInvalid";
import DeleteDialogueBox from "components/Common/deleteDialogue";
import { CommonUtilities } from "commonUtils";

export default function DataLoaderEditLoad(param: any) {

    let [DataLoaderEditData, setDataLoaderEditData] = useState<any>([]);
    let [inputHeader, setInputHeader] = useState<string[]>([]);
    let [inputValue, setInputValue] = useState<string[]>([]);
    let [formData, setFormData] = useState<any>([]);
    let [openFirst, setOpenFirst] = React.useState(false);

    const returnValue = (e: any) => { param.onChangeEditLoad(e); setOpenFirst(false) }

    console.log(param)
    useEffect(() => {
        apiCall();
    }, [param.type, param.subType]);

    const headerMapping = (apiData: any) => {

        Object.entries(apiData).map(([key, value]) => {
            const cleanKey = key.includes(",") ? key.split(",")[0] : key;
            console.log("key:", cleanKey, "value:", value);
            inputHeader.push(cleanKey)
            inputValue.push(value?.toString() ?? "")
        });
        setInputHeader(inputHeader)
        setInputValue(inputValue)
    }

    const formatLabel = (str: any) => {
        return str
            .replace(/([A-Z])/g, ' $1')
            .replace(/\bUrl\b/g, 'URL')
            .replace(/\bId\b/g, 'ID')
            .replace(/^./, (c: any) => c.toUpperCase());
    }

    const saveUploadEdit = () => {

        CommonUtilities.APILoadingToast('Loading', 'fail')
        if (param.type == 'Contacts') {
            dataLoaderServices.DataloaderContactSave(DataLoaderEditData).then((res: any) => {
                apiRespondMgt(res, "Save")
            })
        }

        if (param.type == 'Contracts') {
            dataLoaderServices.DataloadercontractSave(DataLoaderEditData).then((res: any) => {
                apiRespondMgt(res, "Save")
            })
        }

        if (param.type == 'Contract Links') {
            dataLoaderServices.DataloadercontractSave(DataLoaderEditData).then((res: any) => {
                apiRespondMgt(res, "Save")
            })
        }

        if (param.type == 'Release/Track' && param.subType == 'releaseTrack') {
            dataLoaderServices.DataloaderMetaDataGenericSave(DataLoaderEditData).then((res: any) => {
                apiRespondMgt(res, "Save")
            })
        }

        if (param.type == 'Release/Track' && param.subType == 'Releases') {
            dataLoaderServices.DataloaderMetaDataGenericCompilationsSave(DataLoaderEditData).then((res: any) => {
                apiRespondMgt(res, "Save")
            })
        }

        if (param.type == 'Release/Track' && param.subType == 'Track') {
            dataLoaderServices.DataloaderMetaDataGenericTrackSave(DataLoaderEditData).then((res: any) => {
                apiRespondMgt(res, "Save")
            })
        }

        if (param.type == 'CUE') {
            dataLoaderServices.DataloaderCueSave(DataLoaderEditData).then((res: any) => {
                apiRespondMgt(res, "Save")
            })
        }

        if (param.type == 'Song') {
            dataLoaderServices.DataloaderSongMetaDataSave(DataLoaderEditData).then((res: any) => {
                apiRespondMgt(res, "Save")
            })
        }

        if (param.type == 'Minimum Set Uploader') {

            if (param.subType == 'Track') {
                dataLoaderServices.DataloaderMinUploaderTrackDelete(DataLoaderEditData).then((res: any) => {
                    apiRespondMgt(res, "Save");
                });
            }

            if (param.subType == 'Releases') {
                dataLoaderServices.DataloaderMinSetReleaseSave(DataLoaderEditData).then((res: any) => {
                    apiRespondMgt(res, "Save");
                });
            }

            if (param.subType == 'Dealerprice') {
                dataLoaderServices.DataloaderMinSetDealerPriceSave(DataLoaderEditData).then((res: any) => {
                    apiRespondMgt(res, "Save");
                });
            }

            if (param.subType == 'releaseTrack') {
                dataLoaderServices.DataloaderMinSetReleaseTrackSave(DataLoaderEditData).then((res: any) => {
                    apiRespondMgt(res, "Save");
                });
            }

            if (param.subType == 'Songs') {
                dataLoaderServices.DataloaderMinSetSongSave(DataLoaderEditData).then((res: any) => {
                    apiRespondMgt(res, "Save");
                });
            }
        }

        console.log(param)
        console.log(DataLoaderEditData)
    }

    const apiRespondMgt = (respond: any, respondFor: any) => {

        if (respond) {
            apiCall();
            CommonUtilities.CancelAPILoadingToast();
            CommonUtilities.showToastDawer(respondFor + " Successful", "Success");
        }

        if (!respond) {
            CommonUtilities.CancelAPILoadingToast();
            CommonUtilities.showToastDawer(respondFor + " fail", "fail");
        }
    }

    const editData = (headerName: any, values: any) => {
        console.log(headerName)
        console.log(values)

        console.log(DataLoaderEditData[headerName])
        setDataLoaderEditData({ ...DataLoaderEditData, [headerName]: values })
    }

    const apiCall = () => {

        CommonUtilities.APILoadingToast('Loading', 'fail')
        inputHeader = [];
        inputValue = [];

        if (param.type == "Contacts") {
            dataLoaderServices.DataloaderContactGetById(param?.data?.contactUploadID).then((res: any) => {
                DataLoaderEditData = res
                setDataLoaderEditData(DataLoaderEditData)
                headerMapping(DataLoaderEditData)

                if (res) {
                    CommonUtilities.CancelAPILoadingToast();
                }
            });
        }

        if (param.type == "Contracts") {
            dataLoaderServices.DataloadercontractGetById(param?.data?.contractUploadID).then((res: any) => {
                DataLoaderEditData = res
                setDataLoaderEditData(DataLoaderEditData)
                headerMapping(DataLoaderEditData)

                if (res) {
                    CommonUtilities.CancelAPILoadingToast();
                }
            });
        }

        if (param.type == "Contract Links") {
            dataLoaderServices.DataloadercontractLinkGetById(param?.data?.contractLinkUploadID).then((res: any) => {
                DataLoaderEditData = res
                setDataLoaderEditData(DataLoaderEditData)
                headerMapping(DataLoaderEditData)

                if (res) {
                    CommonUtilities.CancelAPILoadingToast();
                }
            });
        }

        if (param.type == "CUE") {
            dataLoaderServices.DataloaderCueGetById(param?.data?.tempTableCUEID).then((res: any) => {
                DataLoaderEditData = res
                setDataLoaderEditData(DataLoaderEditData)
                headerMapping(DataLoaderEditData)

                if (res) {
                    CommonUtilities.CancelAPILoadingToast();
                }
            });
        }

        if (param.type == "Song") {
            dataLoaderServices.DataloaderSongMetaDataGetById(param?.data?.tempTableSongID).then((res: any) => {
                DataLoaderEditData = res
                setDataLoaderEditData(DataLoaderEditData)
                headerMapping(DataLoaderEditData)

                if (res) {
                    CommonUtilities.CancelAPILoadingToast();
                }
            });
        }

        if (param.type == "Minimum Set Uploader" && param.subType == "Tracks") {
            dataLoaderServices.TrackUploaderById(param?.data?.trackUploadId).then((res: any) => {
                DataLoaderEditData = res
                setDataLoaderEditData(DataLoaderEditData)
                headerMapping(DataLoaderEditData)

                if (res) {
                    CommonUtilities.CancelAPILoadingToast();
                }
            });
        }

        if (param.type == "Minimum Set Uploader" && param.subType == "Releases") {
            dataLoaderServices.ReleaseUploaderById(param?.data?.releaseUploadId).then((res: any) => {
                DataLoaderEditData = res
                setDataLoaderEditData(DataLoaderEditData)
                headerMapping(DataLoaderEditData);

                if (res) {
                    CommonUtilities.CancelAPILoadingToast();
                }
            });
        }

        if (param.type == "Minimum Set Uploader" && param.subType == "Dealerprice") {
            dataLoaderServices.DataloaderDealerPriceGetById(param?.data?.dealerPriceUploadID).then((res: any) => {
                DataLoaderEditData = res
                setDataLoaderEditData(DataLoaderEditData)
                headerMapping(DataLoaderEditData)

                if (res) {
                    CommonUtilities.CancelAPILoadingToast();
                }
            });
        }

        if (param.type == "Minimum Set Uploader" && param.subType == "releaseTrack") {
            dataLoaderServices.releaseTrackUploaderById(param?.data?.releaseTracksUploadId).then((res: any) => {
                DataLoaderEditData = res
                setDataLoaderEditData(DataLoaderEditData)
                headerMapping(DataLoaderEditData)

                if (res) {
                    CommonUtilities.CancelAPILoadingToast();
                }
            });
        }

        if (param.type == "Minimum Set Uploader" && param.subType == "Songs") {
            dataLoaderServices.SongUploaderById(param?.data?.tempTableMinimumSetSongID).then((res: any) => {
                DataLoaderEditData = res
                setDataLoaderEditData(DataLoaderEditData)
                headerMapping(DataLoaderEditData)

                if (res) {
                    CommonUtilities.CancelAPILoadingToast();
                }
            });
        }

        if (param.type == "Release/Track" && param.subType == "releaseTrack") {
            dataLoaderServices.metadataReleaseTrackUploaderById(param?.data?.metaDataGenericTempId).then((res: any) => {
                DataLoaderEditData = res
                setDataLoaderEditData(DataLoaderEditData)
                headerMapping(DataLoaderEditData)

                if (res) {
                    CommonUtilities.CancelAPILoadingToast();
                }
            });
        }

        if (param.type == "Release/Track" && param.subType == "Releases") {
            dataLoaderServices.DataloaderMetaDataGenericCompilationsGetById(param?.data?.MetaDataGenericCompilationsTempId).then((res: any) => {
                DataLoaderEditData = res
                setDataLoaderEditData(DataLoaderEditData)
                headerMapping(DataLoaderEditData)

                if (res) {
                    CommonUtilities.CancelAPILoadingToast();
                }
            });
        }

        if (param.type == "Release/Track" && param.subType == "Track") {
            dataLoaderServices.DataloaderMetaDataGenericTrackGetById(param?.data?.MetaDataGenericTracksTempId).then((res: any) => {
                DataLoaderEditData = res
                setDataLoaderEditData(DataLoaderEditData)
                headerMapping(DataLoaderEditData)

                if (res) {
                    CommonUtilities.CancelAPILoadingToast();
                }
            });
        }
    }

    return (<>

        <div className="ws-12" style={{ maxWidth: "50px !important", top: "100px !important" }}>
            <Modal open={param.open} onClose={() => returnValue(0)} styles={{ modalContainer: { background: 'transparent !important', width: "50% !important" } }} center classNames={{ overlay: '', modal: 'ws-7 paddingCenterBox bgTransparent' }} >

                <div className="ws-12 box">

                    <div className="box-header  noBorderRadius bg-blue pLarge">Edit Upload Data </div>

                    <div className="box landing pm">

                        <div className="ws-12 box pm">
                            {
                                inputHeader?.map((value: any, index: any) => {
                                    return (

                                        <div className="ws-4 ps">
                                            <label htmlFor={value} className=" text-bold ws-12">{formatLabel(value)}</label>
                                            <input className="ws-11" type="text" value={DataLoaderEditData[value]} disabled={value === "contactUploadID" ? true : false}
                                                onChange={(e) => editData(value, e.target.value)}
                                            />
                                        </div>
                                    )
                                })
                            }

                        </div>

                    </div>


                    <div className="ws-12 pm ">
                        <button type="button" className="icon-btn delete pull-right width70 height35" onClick={() => returnValue(0)}>x Close</button>
                        <button type="button" className="icon-btn delete pull-right width70 height35" onClick={apiCall}>↻ Reset</button>
                        <button type="button" className="icon-btn edit pull-right width70 height35" onClick={saveUploadEdit}>✔ Save</button></div>
                </div>


            </Modal>
        </div>
    </>)

}